// src/admin/components/AdBannerEditor.jsx

import BannerContentSection from "./BannerContentSection";
import BannerCTASection from "./BannerCTASection";
import BannerTargetingSection from "./BannerTargetingSection";
import BannerScheduleSection from "./BannerScheduleSection";

export default function BannerEditor({
    formData,
    updateField,
    categories = [],
    posts = [],
}) {

    return (

        <div className="space-y-8">

            <BannerContentSection
                formData={formData}
                updateField={updateField}
            />

            <BannerCTASection
                formData={formData}
                updateField={updateField}
            />

            <BannerTargetingSection
                formData={formData}
                updateField={updateField}
                categories={categories}
                posts={posts}
            />

            <BannerScheduleSection
                formData={formData}
                updateField={updateField}
            />

        </div>

    );

}